import BookingEditor from "../../components/Bookings/BookingEditor";
import BookingEditorWithNationalProgramming from "../../components/Bookings/BookingEditorWithNationalProgramming";
import { LayoutAccent1 } from "../../layouts/Layouts";
import { useAppSelector } from "../../store/hooks";

export default function BookingPage() {
  var isNationalProgrammingEnabled = useAppSelector(
    (root) => root.commonData.data?.isNationalProgrammingEnabled ?? false
  );
  return (
    <LayoutAccent1>
      {isNationalProgrammingEnabled ? <BookingEditorWithNationalProgramming /> : <BookingEditor />}
    </LayoutAccent1>
  );
}
